<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'customer-call-logs'"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "../../_mixins/data-grid.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { CacheService } from "../../_services/cache/cache-service";
import { SalesOrderListService } from "../../_services/api/sales/sales-order-list.service";
import { FeatureStorage } from "../../_services/storage";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG Call Log list >>> ", arguments);
}

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      gcPopupCustomerStatementConfig: {},
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  computed: {
    defaultDateFilterValue() {
      let d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d;
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return [this.CustomerSalesRepresentativeCode];
      else return false;
    },
    setScreenConfig() {
      var config = {
        title: "Customers",
        selectedIndex: GetIndexByTabName("Call Logs"),
        tabs: CustomerTabs,
        exportFileName: "Call Schedule Call Logs",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CallLogList",
              serverPaging: true,
              allowGrouping: false,
              select: ["CallLogRecordID"].concat(
                this.getSelectFields(this.getColumns)
              ),
              postProcessCallback: this.callLogListPostProcessCallback,
            },

            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Call Logs",
                message: "Get Started, Add a Call Log",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/call-logs/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("CallLogs", "create"),
              },
            ],
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "Customer",
          sortIndex: 0,
          cellTemplateRecord: {
            primary: [
              {
                dataField: "CustomerName",
              },
            ],
            secondary: [
              {
                dataField: "CustomerCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "CustomerCode",
              label: "Customer Code",
            },
            {
              dataField: "CustomerName",
              label: "Customer Name",
            },
          ],
          fixed: true,
          fixedPosition: "left",
          allowHiding: false,
        },
        {
          screenField: "CustomerName",
          gridLabel: "CustomerNameFilter", // only added to bypass the having the same 'name' for 2 columns
          dataField: "CustomerName",
          visible: false,
          showInColumnChooser: false,
          dataType: "string",
          type: "Text",
          filterIndex: 0,
          filterDataField: "CustomerSearchText",
        },
        {
          screenField: "CallType",
          gridDataField: "CallType",
          label: "Type",
          dataField: "CallType",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "CallTypeDescription",
              },
            ],
            secondary: [
              {
                dataField: "CallType",
              },
            ],
          },
          exportFields: [
            {
              dataField: "CallType",
              label: "Call Type Code",
            },
            {
              dataField: "CallTypeDescription",
              label: "Call Type Description",
            },
          ],
          filterDataField: "CallType",
          filterIndex: 3,
          maxWidth: ColumnWidth.CustomerType.width,
        },
        {
          screenField: "Date",
          sortOrder: "desc",
          dataField: "CallDate",
          filterDataField: "CallDate",
          filterIndex: 2,
          filterOperator: ">",
          filterDefaultValue: this.defaultDateFilterValue,
          label: "Start Date",
          filterLabel: "Start Date",
        },
        {
          screenField: "CallStartTime",
          label: "Start Time",
          filterDataField: "CallStartTime",
          dataField: "CallStartTime",
          type: "Time",
          displayFormat: "hh:mm",
          maxWidth: ColumnWidth.Time.width,
        },
        {
          screenField: "CallEndTime",
          label: "End Time",
          dataField: "CallEndTime",
          filterDataField: "CallEndTime",
          type: "Time",
          maxWidth: ColumnWidth.Time.width,
        },
        {
          screenField: "CallDuration",
          label: "Duration (mins)",
          dataField: "CallDuration",
          filterDataField: "CallDuration",
          maxWidth: ColumnWidth.Duration.width,
        },
        {
          screenField: "NoteCount",
          label: "# Notes",
          dataField: "NoteCount",
          filterDataField: "NoteCount",
          maxWidth: ColumnWidth.Duration.width,
        },
        {
          screenField: "NoteImagesMetaCount",
          label: "# Media",
          dataField: "NoteImagesMetaCount",
          filterDataField: "NoteImagesMetaCount",
          maxWidth: ColumnWidth.Duration.width,
        },
        {
          screenField: "SalesRepresentative",
          label: "Sales Rep",
          dataField: "CustomerSalesRepresentativeCode",
          filterLabel: "Sales Rep",
          filterDataField: "CustomerSalesRepresentativeCode",
          filterIndex: 1,
          visible: false,
          showInColumnChooser: false,
          filterDefaultValue: this.getCustomerRepDefault,
        },
        {
          screenField: "ChangedBy",
          label: "Changed By",
          dataField: "ChangedBy",
          filterLabel: "Changed By",
          filterDataField: "ChangedBy",
          filterIndex: 4,
          maxWidth: ColumnWidth.RepCode.width,
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "OrderStatus",
          gridDataField: "Status",
          gridLabel: "Status",
          dataField: "Status",
          filterDataField: "Status",
          filterIndex: 5,
          dataSourceConfig: {
            data: [
              { key: "A", value: "Active" },
              { key: "C", value: "Complete" },
              { key: "P", value: "Pending" },
              { key: "X", value: "Cancelled" },
            ],
          },
          valueExpr: "key",
          displayExpr: "value",
          filterDefaultValue: ["A", "C"],
        },

        {
          screenField: "GridRecordEllipsisMenu",
          select: false,
          allowSearch: false,
          cssClass: "padding-7",
          ellipsisMenu: {
            itemAction: (data) => {
              var items = [
                {
                  menuText: "Customer List",
                  data: data,
                  clickAction: this.navigateToDestination,
                  disabled: false,
                },
              ];

              return items;
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
          // eslint-disable-next-line no-unused-vars
          makeDisabled: (data) => {
            // if (data) return data.data.Status != "C";
            return true;
          },
        },
      ];
    },
  },
  methods: {
    callLogListPostProcessCallback(data) {
      data.forEach((element) => {
        if (element.CallDate)
          element.CallDate = element.CallDate.dateWithOffset();

        if (element.CallStartTime)
          element.CallStartTime = element.CallStartTime.dateWithOffset();

        if (element.CallEndTime)
          element.CallEndTime = element.CallEndTime.dateWithOffset();
      });
      return data;
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesOrderListService.getUserDefaultSalesRepresentative()
          .then((result) => {
            logDev(
              "SalesOrderListService.getUserDefaultSalesRepresentative",
              result
            );
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
            this.loaded = true;
          })
          .catch((err) => {
            logDev(
              "Error in SalesOrderListService.getUserDefaultSalesRepresentative",
              err
            );

            if (err) {
              this.setLoading = false;
              this.loaded = true;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;

        this.loaded = true;
      }
    },
    goToCustomerStatementModel(e) {
      this.gcPopupCustomerStatementConfig = {
        visible: true,
        hidden: () => {
          this.gcPopupCustomerStatementConfig.visible = false;
        },
        dataModel: e,
      };
    },
    // eslint-disable-next-line no-unused-vars
    navigateToDestination(e) {
      this.$router.push({
        path: `customer`,
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "call-logs",
          mode: "review",
          idProperty: "CallLogRecordID",
          query: { from: "call-logs" },
        });
      }
    },
  },

  async created() {
    this.setLoading = true;
    await this.setDefaultCustomerRep();
  },
};
</script>

<style lang="scss"></style>
